import React from 'react'
import SkinozLogo from './SkinozLogo'
import { LOADER_LOGO_SRC } from '../config/brand'

/**
 * Логотип SKINOZ с glitch-анимацией (используется в прелоадере приложения).
 * Базовый слой + два цветных слоя (info/error), которые рвутся
 * горизонтальными срезами. Keyframes — блок glitch в src/index.css.
 * При заданном LOADER_LOGO_SRC слои строятся из картинки: цветные слои —
 * её силуэт через CSS-маску; при null — исходный SVG.
 */
const GlitchLogo = ({ className = '' }) => {
  if (LOADER_LOGO_SRC) {
    const maskStyle = { WebkitMaskImage: `url("${LOADER_LOGO_SRC}")`, maskImage: `url("${LOADER_LOGO_SRC}")` }
    return (
      <div className={`loader-logo-glitch ${className}`}>
        <img src={LOADER_LOGO_SRC} alt="SKINOZ" className="glitch-base block w-full h-auto" />
        <div className="glitch-layer glitch-mask glitch-layer-a" style={maskStyle} aria-hidden="true" />
        <div className="glitch-layer glitch-mask glitch-layer-b" style={maskStyle} aria-hidden="true" />
      </div>
    )
  }

  return (
    <div className={`loader-logo-glitch ${className}`}>
      <SkinozLogo className="glitch-base w-full h-auto" />
      <SkinozLogo className="glitch-layer glitch-layer-a w-full h-full" />
      <SkinozLogo className="glitch-layer glitch-layer-b w-full h-full" />
    </div>
  )
}

export default GlitchLogo
